module.exports = {"build":594}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 597
// module chunks = 0